import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const PROGRESS_BAR_DOTS = '[data-free-shipping-progress-bar-dots]'
const MESSAGE_NODE_SELECTOR = '[data-free-shipping-bar-message]'
const DIFFERENCE_ATTRIBUTE = 'data-free-shipping-difference'
const DIFFERENCE_PERCENT_ATTRIBUTE = 'data-free-shipping-difference-percent'
const PROGRESS_MESSAGE_ATTRIBUTE = 'data-progress-message'
const ACHIEVED_MESSAGE_ATTRIBUTE = 'data-achieved-message'

export class FreeShippingBar extends BaseComponent {
  constructor() {
    super()
    this.updateProgressByDifference(
      this.getAttribute(DIFFERENCE_ATTRIBUTE),
      +this.getAttribute(DIFFERENCE_PERCENT_ATTRIBUTE),
    )
  }

  updateProgressByDifference(
    difference: string,
    differencePercent: number,
  ): void {
    const progressMessage = this.getAttribute(PROGRESS_MESSAGE_ATTRIBUTE) ?? ''
    const achievedMessage = this.getAttribute(ACHIEVED_MESSAGE_ATTRIBUTE) ?? ''

    if (differencePercent < 100) {
      this.setText(progressMessage.replace('[value]', difference))
      this.setProgress(differencePercent)
    } else {
      this.setText(achievedMessage)
      this.setProgress(100)
    }
  }

  setProgress = (value: number): void => {
    const dots = $el(PROGRESS_BAR_DOTS, this)

    if (dots) {
      dots.style.transform = `translateX(${value}%)`
    }
  }

  setText = (text: string): void => {
    const messageNode = $el(MESSAGE_NODE_SELECTOR, this)
    messageNode?.replaceChildren(text)
  }

  checkAndAddFreeItem = (): void => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bikeProductId = 14660768792948
        const freeVariantId1 = 42443111661751
        const freeVariantId2 = 42443111792823
        const bikeItems = cart.items.filter(
          item => item.product_id === bikeProductId,
        )

        if (bikeItems.length === 0) return
        const totalBikeQuantity = bikeItems.reduce(
          (sum, item) => sum + item.quantity,
          0,
        )
        if (totalBikeQuantity < 2) return

        const greenVariantIds = [54151595327860, 54151595360628]
        const hasGreen = bikeItems.some(item =>
          greenVariantIds.includes(item.variant_id),
        )
        if (!hasGreen) return

        const hasFree1 = cart.items.some(
          item => item.variant_id === freeVariantId1,
        )
        const hasFree2 = cart.items.some(
          item => item.variant_id === freeVariantId2,
        )
        if (hasFree1 || hasFree2) return

        const button = document.querySelector<HTMLElement>('.add_free_item_1')
        button?.click()
      })
      .catch(error => console.error('获取购物车失败', error))
  }
}
